import { request } from "../../proto/bundle";
import { getConnectionPool } from "../../core/connectionPool";
import { checkMigrate } from "../../init/sdkInit";

const ROLEPERMISSIONS = [
    "RemoveUser",
    "PasswordReset",
    // "InitiatePayment",
    "InviteUser",
    "AddPin",
    "GetChunk",
    "StartWrite",
    "PutChunk",
    "FinalizeWrite",
    "CreateFolder",
    // "VerifyPayment",
    // "GetSecret",
    // "AddSecret",
    // "DeleteSecret",
    // "UpdateSecret",
    // "ListSecrets",
    // "QuickListSecrets",
    // "ListSecretSubkeys",
    // "UndeleteSecret",
    // "DestroySecret",
    // "AddRole",
    // "RemoveRole",
    // "UpdateRole",
    "ListRoles",
    "GetRole",
    // "AddTeam",
    // "RemoveTeam",
    // "UpdateTeam",
    "ListTeams",
    "GetTeam",
    "MoveFile",
    "MoveFolder",
    "CopyFile",
    // "CopyFolder",
    // "RestoreVersion",
    "RemoveFile",
    "RemoveFolder",
    "UntrashFile",
    "UntrashFolder",
    "RenameFile",
    "RenameFolder",
    "List",
    // "AuditLogMessage",
    "ResetVersion",
    "Share",
    "Unshare",
    "UpdateShare",
    "ListShares",
    "SetRolesTeamsToUser",
    "UpdatePin",
    // "RestartPutChunk",
    "ListPins",
    "GetMetaFromPath",
    "ListFiles",
    "UpdateTags",
    "AddComment",
    "GetComment",
    "UpdateComment",
    "RemoveComment",
    "ListComments",
    // "ValiDateCoupon",
    "RemoveVersion",
    "EmptyTrash",
    "YSentinel",
    // "CreateAlert",
    // "ListAlerts",
    // "DeleteAlert",
    // "UpdateAlert",
    "BlockUser",
    "UnblockUser",

    "AddSpace",
    "AddUserToSpace",
    "RemoveUserFromSpace",
    "UpdatePermissionsOfSpace",
    "AddObjectToSpace",
    "RemoveObjectFromSpace",
    "RemoveSpace",
    "SendOtpToExternalUser",
    "SignInToSpace",
    "ListSpaces",
    "UpdateOrganizationSettings",
    "GetOrganizationSettings"
]

const STRINGTONUMBER: { [key: string]: number } = {
    "RemoveUser": 2,
    "PasswordReset": 3,
    // "InitiatePayment": 6,
    "InviteUser": 9,
    "AddPin": 15,
    "GetChunk": 21,
    "StartWrite": 22,
    "PutChunk": 23,
    "FinalizeWrite": 24,
    "CreateFolder": 30,
    // "VerifyPayment": 32,
    // "GetSecret": 33,
    // "AddSecret": 34,
    // "DeleteSecret": 35,
    // "UpdateSecret": 36,
    // "ListSecrets": 37,
    // "QuickListSecrets": 87,
    // "ListSecretSubkeys": 38,
    // "UndeleteSecret": 39,
    // "DestroySecret": 40,
    // "AddRole": 41,
    // "RemoveRole": 42,
    // "UpdateRole": 43,
    "ListRoles": 44,
    "GetRole": 81,
    // "AddTeam": 46,
    // "RemoveTeam": 47,
    // "UpdateTeam": 48,
    "ListTeams": 45,
    "GetTeam": 80,
    "MoveFile": 50,
    "MoveFolder": 51,
    "CopyFile": 52,
    // "CopyFolder": 53,
    // "RestoreVersion": 82,
    "RemoveFile": 55,
    "RemoveFolder": 56,
    "UntrashFile": 57,
    "UntrashFolder": 58,
    "RenameFile": 62,
    "RenameFolder": 63,
    "List": 64,
    // "AuditLogMessage": 65,
    "ResetVersion": 66,
    "Share": 73,
    "Unshare": 74,
    "UpdateShare": 75,
    "ListShares": 76,
    "SetRolesTeamsToUser": 83,
    "UpdatePin": 84,
    // "RestartPutChunk": 88,
    "ListPins": 91,
    "GetMetaFromPath": 17,
    "ListFiles": 25,
    "UpdateTags": 107,
    "AddComment": 108,
    "GetComment": 109,
    "ListComments": 110,
    "RemoveComment": 111,
    "UpdateComment": 112,
    // "ValidateCoupon": 115,
    "RemoveVersion": 116,
    "EmptyTrash": 118,
    "YSentinel": 121,
    // "CreateAlert": 122,
    // "ListAlerts": 123,
    // "DeleteAlert": 124,
    // "UpdateAlert": 125,
    "BlockUser": 126,
    "UnblockUser": 127,
    "AddSpace": 97,
    "AddUserToSpace": 98,
    "RemoveUserFromSpace": 99,
    "UpdatePermissionsOfSpace": 100,
    "AddObjectToSpace": 101,
    "RemoveObjectFromSpace": 102,
    "RemoveSpace": 103,
    "SendOtpToExternalUser": 104,
    "SignInToSpace": 105,
    "ListSpaces": 106,
    "UpdateOrganizationSettings": 128,
    "GetOrganizationSettings": 129,

};
const NUMBERTOSTRING: { [key: number]: string } = {
    2: "RemoveUser",
    3: "PasswordReset",
    // 6: "InitiatePayment",
    9: "InviteUser",
    15: "AddPin",
    21: "GetChunk",
    22: "StartWrite",
    23: "PutChunk",
    24: "FinalizeWrite",
    30: "CreateFolder",
    // 32: "VerifyPayment",
    // 33: "GetSecret",
    // 34: "AddSecret",
    // 35: "DeleteSecret",
    // 36: "UpdateSecret",
    // 37: "ListSecrets",
    // 87: "QuickListSecrets",
    // 38: "ListSecretSubkeys",
    // 39: "UndeleteSecret",
    // 40: "DestroySecret",
    // 41: "AddRole",
    // 42: "RemoveRole",
    // 43: "UpdateRole",
    44: "ListRoles",
    81: "GetRole",
    // 46: "AddTeam",
    // 47: "RemoveTeam",
    // 48: "UpdateTeam",
    45: "ListTeams",
    80: "GetTeam",
    50: "MoveFile",
    51: "MoveFolder",
    52: "CopyFile",
    // 53: "CopyFolder",
    // 82: "RestoreVersion",
    55: "RemoveFile",
    56: "RemoveFolder",
    57: "UntrashFile",
    58: "UntrashFolder",
    62: "RenameFile",
    63: "RenameFolder",
    64: "List",
    // 65: "AuditLogMessage",
    66: "ResetVersion",
    73: "Share",
    74: "Unshare",
    75: "UpdateShare",
    76: "ListShares",
    83: "SetRolesTeamsToUser",
    84: "UpdatePin",
    // 88: "RestartPutChunk",
    91: "ListPins",
    17: "GetMetaFromPath",
    25: "ListFiles",
    107: "UpdateTags",
    108: "AddComment",
    109: "GetComment",
    110: "ListComments",
    111: "RemoveComment",
    112: "UpdateComment",
    // 115: "ValidateCoupon",
    116: "RemoveVersion",
    118: "EmptyTrash",
    121: "YSentinel",
    // 122: "CreateAlert",
    // 123: "ListAlerts",
    // 124: "DeleteAlert",
    // 125: "UpdateAlert",
    126: "BlockUser",
    127: "UnblockUser",
    97: "AddSpace",
    98: "AddUserToSpace",
    99: "RemoveUserFromSpace",
    100: "UpdatePermissionsOfSpace",
    101: "AddObjectToSpace",
    102: "RemoveObjectFromSpace",
    103: "RemoveSpace",
    104: "SendOtpToExternalUser",
    105: "SignInToSpace",
    106: "ListSpaces",
    128: "UpdateOrganizationSettings",
    129: "GetOrganizationSettings",

};
/*
    0 - user control ops
    1 - file and folder related ops
    2 - audit ops
    3 - secret ops
*/
export const getTypeOfOp = (op: string) => {
    if (op === "RemoveUser") return 0;
    if (op === "PasswordReset") return 0;
    // if (op === "InitiatePayment") return 0;
    if (op === "InviteUser") return 0;
    // if (op === "VerifyPayment") return 0;
    // if (op === "AddRole") return 0;
    // if (op === "RemoveRole") return 0;
    // if (op === "UpdateRole") return 0;
    if (op === "ListRoles") return 0;
    if (op === "GetRole") return 0;
    // if (op === "AddTeam") return 0;
    // if (op === "RemoveTeam") return 0;
    // if (op === "UpdateTeam") return 0;
    if (op === "ListTeams") return 0;
    if (op === "GetTeam") return 0;
    if (op === "SetRolesTeamsToUser") return 0;
    // if (op === "ValidateCoupon") return 0;
    if (op === "BlockUser " || op === "UnBlockUser") return 0;
    if (op === "UpdateOrganizationSettings" ||
        "GetOrganizationSettings") return 0;
    if (op === "GetChunk") return 1;
    if (op === "StartWrite") return 1;
    if (op === "PutChunk") return 1;
    if (op === "FinalizeWrite") return 1;
    if (op === "CreateFolder") return 1;
    if (op === "MoveFile") return 1;
    if (op === "MoveFolder") return 1;
    if (op === "CopyFile") return 1;
    // if (op === "CopyFolder") return 1;
    // if (op === "RestoreVersion") return 1;
    if (op === "RemoveFile") return 1;
    if (op === "RemoveFolder") return 1;
    if (op === "UntrashFile") return 1;
    if (op === "UntrashFolder") return 1;
    if (op === "RenameFile") return 1;
    if (op === "RenameFolder") return 1;
    if (op === "List") return 1;
    if (op === "ResetVersion") return 1;
    if (op === "Share") return 1;
    if (op === "Unshare") return 1;
    if (op === "UpdateShare") return 1;
    if (op === "ListShares") return 1;
    // if (op === "RestartPutChunk") return 1;
    if (op === "UpdateTags") return 1;
    if (op === "AddComment") return 1;
    if (op === "RemoveComment") return 1;
    if (op === "ListComments") return 1;
    if (op === "UpdateComment") return 1;
    if (op === "GetComment") return 1;
    if (op === "RemoveVersion") return 1;
    if (op === "EmptyTrash") return 1;

    if (
        op === "YSentinel"
        // op === "CreateAlert" ||
        // op === "ListAlerts" ||
        // op === "DeleteAlert" ||
        // op === "UpdateAlert"
    ) {
        return 2;
    }

    // if (op === "GetSecret") return 3;
    // if (op === "AddSecret") return 3;
    // if (op === "DeleteSecret") return 3;
    // if (op === "UpdateSecret") return 3;
    // if (op === "ListSecrets") return 3;
    // if (op === "QuickListSecrets") return 3;
    // if (op === "ListSecretSubkeys") return 3;
    // if (op === "DestroySecret") return 3;
    // if (op === "UndeleteSecret") return 3;
    if (
        op === "AddSpace" ||
        op === "AddUserToSpace" ||
        op === "RemoveUserFromSpace" ||
        op === "UpdatePermissionsOfSpace" ||
        op === "AddObjectToSpace" ||
        op === "RemoveObjectFromSpace" ||
        op === "RemoveSpace" ||
        op === "SendOtpToExternalUser" ||
        op === "SignInToSpace" ||
        op === "ListSpaces"
    ) {
        return 4;
    }
    return -1;
};

export class Role {
    constructor(
        private name: string,
        private permissions: string[]
    ) { }

    public getName(): string {
        return this.name;
    }
    public setName(name: string): void {
        this.name = name;
    }
    public getPermissions(): string[] {
        return this.permissions;
    }
    public setPermissions(permissions: string[]): void {
        this.permissions = permissions;
    }
    public static getPermission(
        numb: number
    ): string {
        try {
            return NUMBERTOSTRING[numb];
        } catch {
            return ""
        }
    }

    public static async addRole(
        name: string,
        permissions: string[]
    ) {
        const Op: number[] = [];
        for (const perm of permissions) {
            Op.push(STRINGTONUMBER[perm])
        }
        const addRole = request.AddRole.create({ name, permissions: Op })
        const req = request.Request.create({ id: null, reqCreateTime: Date.now(), addRole })
        const pool = await getConnectionPool()
        const resp = await pool.sendAndWait(req)
        checkMigrate(resp.addRole.status)
        if (resp?.addRole?.status !== 0) {
            throw new Error(resp?.addRole?.message ?? "Failed to add role")
        }
    }

    public static async updateRole(
        name: string,
        permissions: string[]
    ) {
        const Op: number[] = [];
        for (const perm of permissions) {
            Op.push(STRINGTONUMBER[perm])
        }
        const updateRole = request.UpdateRole.create({ name, permissions: Op })
        const req = request.Request.create({ id: null, reqCreateTime: Date.now(), updateRole })
        const pool = await getConnectionPool()
        const resp = await pool.sendAndWait(req)
        checkMigrate(resp.updateRole.status)
        if (resp?.updateRole?.status !== 0) {
            throw new Error(resp?.updateRole?.message ?? "Failed to update role")
        }
    }

    public static async removeRole(
        name: string
    ) {
        const removeRole = request.RemoveRole.create({ name })
        const req = request.Request.create({ id: null, reqCreateTime: Date.now(), removeRole })
        const pool = await getConnectionPool()
        const resp = await pool.sendAndWait(req)
        checkMigrate(resp.removeRole.status)
        if (resp?.removeRole?.status !== 0) {
            throw new Error(resp?.removeRole?.message ?? "Failed to remove role")
        }
    }

    public static async getRole(
        name: string
    ): Promise<Role> {
        const getRole = request.GetRole.create({ name })
        const req = request.Request.create({ id: null, reqCreateTime: Date.now(), getRole })
        const pool = await getConnectionPool()
        const resp = await pool.sendAndWait(req)
        checkMigrate(resp.getRole.status)

        if (resp?.getRole?.status !== 0) {
            throw new Error(resp?.getRole?.message ?? "Failed to get role")
        }

        const role = request.Role.decode(resp?.getRole?.role ?? new Uint8Array)

        return new Role(
            role.name,
            role.permissions.map((val) => NUMBERTOSTRING[val])
        )
    }

    public static async listRoleNames(

    ): Promise<string[]> {
        let listRoles = request.ListRoles.create({})
        let req = request.Request.create({ id: null, reqCreateTime: Date.now(), listRoles })
        let pool = await getConnectionPool()
        let resp = await pool.sendAndWait(req)
        checkMigrate(resp.listRoles.status)

        if (resp?.listRoles?.status !== 0) {
            throw new Error(resp?.listRoles?.message ?? "List Roles failed!!!")
        }

        return resp?.listRoles?.roles ?? []
    }

    public static async listRoles(

    ): Promise<Role[]> {
        let listRoles = request.ListRoles.create({})
        let req = request.Request.create({ id: null, reqCreateTime: Date.now(), listRoles })
        let pool = await getConnectionPool()
        let resp = await pool.sendAndWait(req)
        checkMigrate(resp.listRoles.status)

        if (resp?.listRoles?.status !== 0) {
            throw new Error(resp?.listRoles?.message ?? "List Roles failed!!!")
        }

        const rolesList = resp?.listRoles?.roles ?? []
        const roles: Role[] = [];
        for (const roleName of rolesList) {
            roles.push(await this.getRole(roleName))
        }

        return roles
    }
}


export function getPermissionNumber(
    permission: string
): number {
    return STRINGTONUMBER[permission] ?? -1;
}

export function getPermissionString(
    permission: number
): string {
    return NUMBERTOSTRING[permission] ?? "";
}
export function listPermissions(

): string[] {
    return ROLEPERMISSIONS;
}
